import { render } from "./MegaMenu.vue?vue&type=template&id=3601b291&scoped=true"
import script from "./MegaMenu.vue?vue&type=script&lang=js"
export * from "./MegaMenu.vue?vue&type=script&lang=js"

import "./MegaMenu.vue?vue&type=style&index=0&id=3601b291&scoped=true&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3601b291"]])

export default __exports__